type MediaType = { id: string; provider: 'youtube' | 'vimeo' | 'html5' }

export const parseMediaVideoFile = (url: string): MediaType => {
  function getQueryVariable(variable: any, url: URL) {
    try {
      const query = url.search.substring(1)
      const vars = query.split('&')
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i]?.split('=')
        if (
          pair != undefined &&
          pair[0] != undefined &&
          decodeURIComponent(pair[0]) === variable &&
          pair[1] != undefined
        )
          return decodeURIComponent(pair[1])
      }
      //console.log('Video query variable %s not found', variable);
    } catch (e) {}
    return undefined
  }

  let res: MediaType = { id: '', provider: 'youtube' }

  try {
    const url1 = new URL(url)
    // Support `youtube` and `youtu.be`
    if (url1.hostname.toLowerCase().includes('youtu')) {
      let id = getQueryVariable('v', url1)
      if (id == undefined) {
        id = url1.pathname.substring(1)
      }
      res = {
        id: id,
        provider: 'youtube',
      }
    } else if (url1.hostname.toLowerCase().includes('vimeo')) {
      let id = url1.pathname.substring(1)
      res = {
        id: id,
        provider: 'vimeo',
      }
    } else {
      res = {
        id: url,
        provider: 'html5',
      }
    }
  } catch (e) {}
  return res
}
